// extracted by mini-css-extract-plugin
export var menuItem = "w_tK d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "w_tL d_Z d_bz d_bP";
export var menuMainLink = "w_tM d_f0 d_dB";
export var menuLink = "w_tN d_f0 d_dB";
export var icon = "w_p7 d_bC d_bP";
export var divider = "w_tP d_bC d_bP";
export var sublinks = "w_tQ";
export var link = "w_mC";
export var Link = "w_rG q_rG q_qT q_rc";